import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-lata-mangeshkar-akola-event',
  templateUrl: './lata-mangeshkar-akola-event.component.html',
  styleUrls: ['./lata-mangeshkar-akola-event.component.scss']
})
export class LataMangeshkarAkolaEventComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
